import { Flex, Text } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import { formatTime } from "constants/commonFunctions";
import { formatDateToDDMONTHNAMEYYYY } from "utils/common";

export const recommendationColumns = [
  {
    Header: "PAYMENT ID",
    accessor: "payment_id",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>{value}</Text>
      </Flex>
    ),
  },
  {
    Header: "AMOUNT",
    accessor: "amount",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>{value}</Text>
      </Flex>
    ),
  },
  {
    Header: "STATUS",
    accessor: "status",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>
          <StatusBadge status={value} />
        </Text>
      </Flex>
    ),
  },
  {
    Header: "Order ID",
    accessor: "order_id",
    Cell: ({ value }) => {
      return (
        <a
          href={`/#/admin/subscriptions/?order_id=${value}`}
          target="_blank"
          rel="noreferrer"
          cursor="pointer"
          whiteSpace={"nowrap"}
          style={{ fontSize: "11px", fontWeight: 600, cursor: "pointer" }}
        >
          {value}
        </a>
      );
    },
  },
  {
    Header: "CONTACT",
    accessor: "meta_data",
    Cell: ({ value }) => {
      const phone = value?.contact?.replace(/\D/g, "")?.slice(-10);
      return (
        <Flex align="center" justify={"center"}>
          <Text>{phone || "-"}</Text>
        </Flex>
      );
    },
  },
  {
    Header: "CREATED_BY",
    accessor: "created_by",
    Cell: ({ value }) => {
      return (
        <Flex align="center" justify={"center"}>
          <Text>{value || "-"}</Text>
        </Flex>
      );
    },
  },
  {
    Header: "METHOD",
    accessor: "method",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>{value}</Text>
      </Flex>
    ),
  },
  {
    Header: "CREATED AT",
    accessor: "created_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
];
